import Rhombus from '../../Header/rhombus';
import theme from '../../../theme';
import * as S from './style';
import * as T from '../../Typography';
import { countryType, siteUrl } from '../../../constants/data-types';
import Close from '../../Icon/icons/Close';
import { useTranslation } from 'react-i18next';
import { common } from 'constants';
import { useLanguage } from '../../../helpers';

const PromoCard = ({ country = countryType.SCOTLAND, closeHandler }) => {
  const { t } = useTranslation();
  const { dir } = useLanguage();

  return (
    <S.CardWrapper dir={dir}>
      <S.CardHeader>
        <S.TextContainer dir={dir}>
          <T.H4 color={theme.colors.white} style={{ margin: 0, padding: 0 }}>
            {t(
              'common.section.homePage.liveIn',
              common.section.homePage.liveIn
            )}{' '}
            {country === countryType.SCOTLAND
              ? t(
                  'common.section.homePage.greatBritain',
                  common.section.homePage.greatBritain
                )
              : t(
                  'common.section.homePage.scotland',
                  common.section.homePage.scotland
                )}
          </T.H4>
        </S.TextContainer>
        <S.RhombusWrapper countryType={country} dir={dir}>
          <Rhombus
            height="100%"
            width="100%"
            color={theme.colors.primaryMain}
            borderRadius="5px"
          />
        </S.RhombusWrapper>
        <S.CloseButton onClick={closeHandler} dir={dir}>
          <Close />
        </S.CloseButton>
      </S.CardHeader>
      <S.CardContent countryType={country}>
        <T.P>
          {t(
            'common.section.homePage.countryPromoCard',
            common.section.homePage.countryPromoCard
          )}
          {country === countryType.SCOTLAND
            ? t('common.section.homePage.PIP', common.section.homePage.PIP)
            : t('common.section.homePage.ADP', common.section.homePage.ADP)}
        </T.P>
        <S.LinkContainer>
          <T.Link
            color={theme.colors.secondaryMain}
            external={true}
            target="_self"
            to={
              country === countryType.SCOTLAND
                ? siteUrl.GREAT_BRITAIN
                : siteUrl.SCOTLAND
            }
          >
            {`${t(
              'common.section.homePage.goTo',
              common.section.homePage.goTo
            )} ${country === countryType.SCOTLAND ? 'PIP' : 'ADP'} ${t(
              'common.section.homePage.helper',
              common.section.homePage.helper
            )}`}
          </T.Link>
        </S.LinkContainer>
      </S.CardContent>
    </S.CardWrapper>
  );
};

export default PromoCard;
